import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverTrackingDetailAdminDto } from '@/backend/market'
import { DriverTrackingEntity } from '../../domain/entities/DriverTrackingEntity'

export class DriverTrackingModel extends DriverTrackingEntity {
  constructor(dataDto: DriverTrackingDetailAdminDto) {
    super()
    mapEntityProperties<DriverTrackingEntity>(this, dataDto)
  }
}
